import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React from 'react';
import compose from '../../hoc/compose';
import displayNames from '../displayNames';
import TextLabel from '../textLabel/textLabel';
import InfoIcon from '../infoIcon/infoIcon';

var Stepper = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Stepper, _React$PureComponent);

  var _super = _createSuper(Stepper);

  function Stepper() {
    var _this;

    _classCallCheck(this, Stepper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderSteps", function () {
      if (_typeof(_this.props.steps) === _typeof([])) {
        return _this.props.steps.map(function (step, idx) {
          var title = step.title,
              content = step.content,
              tooltipContent = step.tooltipContent;
          return /*#__PURE__*/React.createElement("div", {
            key: idx,
            "data-hook": "step",
            className: "step"
          }, /*#__PURE__*/React.createElement("div", {
            className: "title-wrapper"
          }, /*#__PURE__*/React.createElement(TextLabel, {
            dataHook: "title",
            className: "title",
            type: "T19",
            value: title
          }), tooltipContent ? /*#__PURE__*/React.createElement(InfoIcon, {
            dataHook: "title-tooltip",
            className: "tooltip",
            text: tooltipContent
          }) : null), /*#__PURE__*/React.createElement("div", {
            className: "content-wrapper"
          }, /*#__PURE__*/React.createElement("div", {
            className: "divider"
          }), /*#__PURE__*/React.createElement("div", {
            "data-hook": "content",
            className: "content"
          }, content)));
        });
      }
    });

    return _this;
  }

  _createClass(Stepper, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          getClassName = _this$props.getClassName,
          dataHook = _this$props.dataHook;
      return /*#__PURE__*/React.createElement("div", {
        "data-hook": dataHook,
        className: getClassName('control-stepper')
      }, this.renderSteps());
    }
  }]);

  return Stepper;
}(React.PureComponent);

Stepper.displayName = displayNames.STEPPER;
Stepper.propTypes = {
  dataHook: PropTypes.string,
  steps: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    content: PropTypes.element,
    tooltipContent: PropTypes.string
  })).isRequired
};
export default compose(Stepper);